// ניהול הסכמת עוגיות (תיקון 13 לחוק הגנת הפרטיות). הבחירה נשמרת ב-localStorage
// עם גרסה וחותמת זמן — העלאת CONSENT_VERSION (למשל אחרי שינוי מהותי במדיניות
// או הוספת עוגיות חדשות) תציג את הבאנר מחדש לכל המשתמשים.
// כל שינוי משודר כאירוע window "cookie-consent" כדי שהבאנר וה-overlays יתעדכנו,
// וכדי שכלי אנליטיקס עתידיים יוכלו להיטען רק אחרי הסכמה (allowsAnalytics).
const KEY = "cookie_consent";
export const CONSENT_VERSION = 1;

// מחזיר { version, level: 'all' | 'essential', at } או null אם טרם ניתנה הסכמה.
export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setCookieConsent(level) {
  const value = { version: CONSENT_VERSION, level, at: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* noop */ }
  try { window.dispatchEvent(new CustomEvent("cookie-consent", { detail: value })); } catch { /* noop */ }
  return value;
}

// מאפס את הבחירה — הבאנר יוצג שוב (משמש את "ניהול העדפות עוגיות" בדף המדיניות).
export function resetCookieConsent() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
  try { window.dispatchEvent(new CustomEvent("cookie-consent", { detail: null })); } catch { /* noop */ }
}

export function hasCookieConsent() {
  return getCookieConsent() !== null;
}

// עוגיות שאינן חיוניות (אנליטיקס וכד') מותרות רק אם המשתמש אישר "הכל".
export function allowsAnalytics() {
  return getCookieConsent()?.level === "all";
}
